import { Typography } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { useT } from '../i18n';
import { RootState } from '../store';

import { PageShell } from './components/PageShell';
import { ReadingView } from './components/ReadingView';

/** A saved reading, shown with every card already turned. */
export const ReadingPage: React.FC = () => {
    const { id } = useParams();
    const t = useT();
    const reading = useSelector((s: RootState) =>
        s.tarot.history.find((r) => r.id === id)
    );
    return (
        <PageShell to="/">
            {reading ? (
                <ReadingView key={reading.id} reading={reading} />
            ) : (
                <Typography
                    color="text.secondary"
                    align="center"
                    sx={{ mt: 4 }}
                >
                    {t('reading.notFound')}
                </Typography>
            )}
        </PageShell>
    );
};
